/**
 * File utilities - Extension handling, filename manipulation, and size formatting.
 *
 * @module file
 */

// Extension utilities
export {
    getExtension,
    getExtensionSimple,
    getExtensionList,
    isKnownSupportedExtension,
    isExtensionDisallowed,
    isExtensionAllowed,
    isThumbnailSupported,
    normalizeExtension,
    extensionsMatch,
} from './extension-utils';

// Filename manipulation
export {
    replaceExtension,
    getBasename,
    getFilenameFromPath,
    getFilename,
    getFileMimeType,
    getFileMimeTypeFromFilename,
    sanitizeFilename,
    truncateFilename,
} from './filename-manipulator';

// File size formatting
export {
    toReadableBytes,
    toReadableBits,
    bytesToMB,
    mbToBytes,
    bytesToGB,
    gbToBytes,
    formatFileSize,
} from './file-size-formatter';
